export const lowerCase = (value) => value && value.toLowerCase();
export const normalizePhoneNumber = (phoneNumberString) => {
    const cleaned = phoneNumberString && (phoneNumberString).replace(/[-()\s]/g, '');
    return cleaned && cleaned.toString().substring(0, 14);
}